"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;



































var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { searchData: { page: 1, rows: 10, appId: '', sn: '', time: '', status: '' }, //筛选参数
      tableColumn: [{ prop: 'appName', label: 'App' }, { prop: 'oldAppVersion', label: '升级前版本' }, { prop: 'newAppVersion', label: '升级后版本' }, { prop: 'sysType', label: '系统类型', formatter: _formatter.sysTypeFormatter }, { prop: 'upgradeStartTime', label: '升级开始时间', formatter: _formatter.dateFormatter }, { prop: 'upgradeEndTime',
        label: '升级结束时间',
        formatter: _formatter.dateFormatter },

      {
        prop: 'isForce',
        label: '是否强制升级',
        formatter: _formatter.otaIsForceFormatter },

      {
        prop: 'rangeType',
        label: '升级范围',
        formatter: _formatter.otaRangeformatter },

      {
        prop: 'sn',
        label: '设备序列号' },

      {
        prop: 'status',
        label: '升级状态',
        formatter: _formatter.appUpgradeLogStatus },

      {
        prop: 'remarks',
        label: '失败原因' }],

      //表头数据
      tableData: [], //表格数据
      appList: [], //App列表
      statusList: [
      {
        id: 0,
        name: '开始升级' },

      {
        id: 1,
        name: '升级成功' },

      {
        id: 2,
        name: '升级失败' }],

      //状态列表
      pageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 }
      //分页数据
    };
  },

  mounted: function mounted() {
    this.fetchLogList();
    this.fetchAppList();
  },

  methods: {
    /**
              * 升级日志
              */
    fetchLogList: function fetchLogList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      if (params.time) {
        params.upgradeStartTime = params.time[0];
        params.upgradeEndTime = params.time[1];
      }
      delete params['time'];
      this.getData('/api/faAppUpgradeLog/getPage', params, function (res) {
        _this.tableData = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 获取App列表
        */
    fetchAppList: function fetchAppList() {var _this2 = this;
      var params = {
        page: 1,
        rows: 9999 };

      this.getData('/api/faAppInfo', params, function (res) {
        _this2.appList = res.list;
      });
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'appId', '');
      this.$set(this.searchData, 'sn', '');
      this.$set(this.searchData, 'time', '');
      this.$set(this.searchData, 'status', '');
      this.$set(this.searchData, 'page', 1);
      this.fetchLogList();
    },

    /**
        * size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.$set(this.searchData, 'rows', val);
      this.$set(this.searchData, 'page', 1);
      this.fetchLogList();
    },

    /**
        * page-chaneg
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.$set(this.searchData, 'page', val);
      this.fetchLogList();
    } } };exports.default = _default;